import React from 'react';
import cn from 'classnames';
import CloseIcon from 'views/components/icons/Close';
import { capacityOnRamps } from './selectOptions';
import DropdownStyles from '../DropdownStyles';
import { getTheme } from 'utils/SelectTheme';
import Select from 'react-select';

const Ems = ({ selectedEms, setSelectedEms, setCapOnRamp, capOnRamp }) => {
  const options = [
    { label: 'All EMS', value: 'emsAll' },
    { label: 'Private Backup', value: 'privateBackup' },
    { label: 'Private Cloud', value: 'privateCloud' },
    { label: 'Firewall', value: 'firewall' },
    { label: 'Domestic Solutions', value: 'domesticSolutions' },
    { label: 'Private NVIDIA AI', value: 'privateNvidiaAI' },
  ];
  return (
    <div className={cn('marketplace-view')} data-testid={'ems-menu'}>
      <ul>
        <li>
          <span className="subsection-title">Show for:</span>
          <div className="select-wrapper">
            <Select
              classNamePrefix="select"
              value={capacityOnRamps.find((i) => i.value === capOnRamp)}
              onChange={(e) => setCapOnRamp(e.value)}
              options={capacityOnRamps}
              isSearchable={false}
              theme={getTheme}
              menuPlacement={'auto'}
              menuPosition={'fixed'}
              styles={DropdownStyles}
            />
          </div>
        </li>
      </ul>
      <div className={'separator-line'} />
      <ul className={cn('actions-list', { disabled: !selectedEms })}>
        <li onClick={() => setSelectedEms(null)}>
          <p>Clear Selection</p>
          <CloseIcon width={10} height={10} color="#000000" />
        </li>
      </ul>
      <div className={'separator-line'} />
      <ul className={'segment-list'}>
        {options.map((option) => (
          <div key={`segment-list-${option.value}`}>
            <li onClick={() => setSelectedEms(option.value)} className={cn('option', { selected: selectedEms === option.value })}>
              {option.label}
            </li>
          </div>
        ))}
      </ul>
    </div>
  );
};

export default Ems;
